import React from "react";
import Label from "components/general/Label"
import { filterArray, findArray } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import { usePositions } from "components/common/Positions";
import Esl from "components/common/Esl";
import { getEvent } from "helpers/rsc"

export const TableExpanded = React.memo((props) => {
    let isTeam = props?.data?.itemType === 'T'
    let esl = props?.data?.extCompetitor;
    const positions = usePositions();
    let intermediates = filterArray(props?.config?.extendedConfig, { code: ['INTERMEDIATE'] })

    return (
        <>
            {positions}
            <Esl data={esl} />
            {isTeam && (getEvent(props?.rsc).includes('K4') || getEvent(props?.rsc).includes('C4'))
                ? <div className='row-competitor-box'>{props?.data?.teamAthletes?.map((ath, index) =>
                    <div className='row-competitor' key={index}>
                        <Competitor {...ath.athlete} hidePicture={true} hideNoc={true} />
                    </div>
                )}</div>
                : <></>
            }
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th className="w-10"></th>
                        <th className="fw-bold text-start"><Label data="HeaderDistance" /></th>
                        <th className="fw-bold text-end w-20"><Label data="HeaderTime" /></th>
                        <th className="fw-bold text-end w-20"><Label data="HeaderRank" sport="CSP" /></th>
                        <th className="fw-bold text-end w-20"><Label data="HeaderTimeBehind" /></th>
                        <th className="w-10"></th>
                    </tr>
                </thead>
                <tbody>
                    {intermediates.map((int, index) => {
                        let label = int.value
                        let value = findArray(props?.data?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [int.pos] }).er_value
                        let rank = findArray(props?.data?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [int.pos] }).er_rank
                        let timeBehind = findArray(props?.data?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [int.pos] }).er_diff
                        return (
                            <tr key={index}>
                                <td></td>
                                <td className="fw-bold text-start">{int.pos === 'F'
                                    ? <Label data="HeaderFinish" />
                                    : label + 'm'}
                                </td>
                                <td className="text-end">{value}</td>
                                <td className="text-end">{rank}</td>
                                <td className="text-end">{timeBehind}</td>
                                <td></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    );
});

export default TableExpanded